import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  FORGOT_PASS_PATH,
  RESET_PASS_PATH,
  SIGNIN_PATH,
  CHECK_EMAIL_PATH,
  SIGNUP_PATH,
  VERIFY_PHONE_PATH,
  WELCOME_PATH,
  SIGNUP_VERIFY_EMAIL_PATH,
  WELCOME_QUESTIONS_PATH,
  PASSWORD_RESET_SUCCESS_PATH,
  PASSWORD_RESET_COMPLETE_PATH,
} from "features/Auth/routes";
import { rememberSettingsReturn } from "./settingsReturn";

// Signing in or out is never a page to come back to after Settings.
const AUTH_PATHS = [
  FORGOT_PASS_PATH,
  RESET_PASS_PATH,
  SIGNIN_PATH,
  CHECK_EMAIL_PATH,
  SIGNUP_PATH,
  VERIFY_PHONE_PATH,
  WELCOME_PATH,
  SIGNUP_VERIFY_EMAIL_PATH,
  WELCOME_QUESTIONS_PATH,
  PASSWORD_RESET_SUCCESS_PATH,
  PASSWORD_RESET_COMPLETE_PATH,
];

// Renders nothing: it records the current page whenever the route or its query
// changes, so closing the Settings modal can return to it.
export const SettingsReturnTracker = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (AUTH_PATHS.some((path) => pathname.startsWith(path))) return;
    rememberSettingsReturn(pathname, search, window.history.state?.idx ?? null);
  }, [pathname, search]);

  return null;
};
